module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chtit"
  }, [_vm._v("Appearance")]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cleanliness")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before starting an account of the intimate lives of medieval people, can we determine what they might have looked like? For a start, and perhaps most importantly, it is extremely unlikely that they were anything like as dirty as the modern imagination might think. Certainly, the Middle Ages was an era long before the invention of power showers, and hot baths – which required the heating of large quantities of water on a fire, numerous containers to fill a bathtub large enough for a person to immerse themselves in, and much manpower to carry away and empty all the containers again – were far too labour-intensive for most people to bother with very often, if at all. This does not, however, mean that people did not wash and keep themselves clean. There was always a possibility to wash with water from a pitcher or basin, even if one could not immerse one’s whole body in hot water. In his will of 1361, Humphrey de Bohun, Earl of Hereford, bequeathed a basin which he used for washing his head to his sister Margaret, Countess of Devon. Margaret herself left a ‘pair of basins which were for washing the hands’ of her late husband Hugh Courtenay to Exeter Cathedral in 1391."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn1",
      "id": "ch1rfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alan Hacford of Norfolk, who worked as a chaplain in the 1320s, owned a ‘brass dish for washing the head’, worth 2d, and in the 1310s Katherine of Lincoln owned a ‘basin with a washing-vessel’ worth the large sum of 4s. An inventory of the goods belonging to the late London fishmonger Thomas Mockyng in 1373 included seven wash-bowls."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn2",
      "id": "ch1rfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" People also often washed in a stream or river, and sometimes took their lives into their hands while doing so; coroners’ rolls reveal that a few people drowned while washing themselves. Robert Waddenho drowned while washing in the River Nene in 1301, Maud Reynald drowned while bathing in a marl pit in Naseby, Northamptonshire in 1309 or"), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" 1310, and sixteen-year-old John Redebourne drowned while bathing in the Houndsditch in London in 1337. A few unfortunate Londoners, including Henry Overestolte in 1340, drowned in the Thames while washing themselves."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn3",
      "id": "ch1rfn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The three related texts about women’s medicine known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotula")]), _vm._v(" (meaning ‘little Trota’, a woman’s name), written in Salerno in the twelfth century, were well-known in medieval England both in the original Latin and in Middle English translation."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn4",
      "id": "ch1rfn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotula")]), _vm._v(" has a long section on how women should bathe and remove their body hair, and for washing one’s hair, it recommends a shampoo of burnt vines, chaff of barley and liquorice wood. It includes tips on how a woman should wear cosmetics, which begins with an instruction that she should ‘wash her face very well with French soap and warm water’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn5",
      "id": "ch1rfn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The fifteenth-century "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boke of Nurture")]), _vm._v(" includes instructions on how to prepare a bath for one’s lord. A servant should hang ‘sheets full of sweet herbs’ from the roof, and ensure that five or six sponges to lean on were available, plus one large sponge to sit on and another under the feet. Using a basin containing hot water and fresh herbs, the lord’s body was to be washed with a soft sponge and afterwards rinsed with warm rose water. The servant should dry him with a clean cloth as he stood on a foot-sheet, then fetch his socks and slippers and take him to bed. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boke")]), _vm._v(" also contains instructions for medicinal baths. For ‘ache’, water as hot as the person could tolerate containing eighteen herbs including St John’s wort, mallow, camomile and brown fennel, was recommended."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn6",
      "id": "ch1rfn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edward I’s daughter Eleanor (1269–98), son Henry (1268–74) and nephew John of Brittany (1266–1334) were bathed regularly by their carers in childhood, and Spanish soap was purchased for the children. Medieval soap came in white, grey and black varieties and could be purchased by the loaf or cake. Eleanor and Henry’s little brother Edward of Caernarfon, aged six, was bathed in 1290 while staying at Banstead in Surrey, and it cost 6d."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn7",
      "id": "ch1rfn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Edward I himself had running water in his tiled bathroom, controlled by gilt bronze taps, and his grandson Edward III had both hot and cold running water in several of his palaces."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn8",
      "id": "ch1rfn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Edward III’s grandson and successor Richard II rebuilt the bathhouse at the royal residence of Langley in Hertfordshire, which had ten glazed windows, and built another luxurious bathhouse at his palace of Sheen with 2,000 painted tiles and large bronze taps for hot and cold water."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn9",
      "id": "ch1rfn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" In his 1354 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Book of Holy Medicines")]), _vm._v(", Henry of"), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" Grosmont ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(". 1310–61), first Duke of Lancaster, a cousin of Edward III and grandfather of Henry IV, described the benefits of a good bath which cleaned the body, and said that afterwards, he felt ‘like a new man’. After the bath, Henry recommended that a person should ‘sweat well’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bien suer")]), _vm._v("). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotula")]), _vm._v(" also described a procedure that sounds exactly like a modern sauna."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn10",
      "id": "ch1rfn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clothes could also be washed in streams or rivers, and in London, there existed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lavenderebrigge")]), _vm._v(", located close to the modern Southwark Bridge. This word literally means ‘Laundress’s Bridge’, though it was a wharf or jetty with steps down to the river where washerwomen worked. Washing clothes was usually a job done by women in late medieval England, though in the early 1300s John Tucke drowned in the village of Glinton (then in Northamptonshire, now in Cambridgeshire) while washing clothes in a stream. Although John’s age is not given, it was possible that he was a child rather than a grown man."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn11",
      "id": "ch1rfn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The mayor and aldermen of London complained in 1417 that owners of ‘certain wharves and stairs on the bank of the Thames’ forced poor people who wished to wash and beat their clothes there to pay for the privilege and ordered them not to do so."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn12",
      "id": "ch1rfn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Noble households employed washerwomen, and in 1318, Amice Maure, Cristiane Scot, Annote Walisshe, ‘dame Gonnore’ and ‘the wife of Simon Gawer’ washed the clothes of the royal household. Edward IV’s household ordinance of 1478 stated ‘if ther be a quene in housholde, than there be women lauenders’ (laundresses), and for the king himself, a servant was to purchase ‘asmuch white sope [soap], gray and blak as can be thought reasonable’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn13",
      "id": "ch1rfn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unpleasant smells, to the medieval mind, signified danger, corruption, spiritual uncleanliness, and death. Herbs and spices were, therefore, often used and scattered around to provide sweet smells."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn14",
      "id": "ch1rfn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Henry of Grosmont wrote in 1354 of his love of the aroma of expensive new cloth, flowers and rich food, and his shame at feeling involuntary revulsion for the stench of his comrades’ wounds and the way poor, sick people smelled."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn15",
      "id": "ch1rfn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Even in an age long before modern dentistry, teeth might not always have been as decayed, rotten and smelly as we might think, given that few people had the chance to consume sugar regularly. When the remains of Bartholomew Burghersh, an English knight who died in 1369 in his late forties, were examined in 1961, he was found to have had a full set of teeth, albeit very worn."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn16",
      "id": "ch1rfn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" For whitening teeth and for curing halitosis caused by rotted gums, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotula")]), _vm._v(" recommended a powder of cinnamon,"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" clove, spikenard, mastic, frankincense, wormwood, crab foot, date pits and olives, to be rubbed onto the teeth and gums. The thirteenth-century physician Gilbertus Anglicus (‘Gilbert the Englishman’), meanwhile, sensibly suggested drying one’s teeth with a linen cloth after eating to ensure that no food stuck to them and rotted them."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn17",
      "id": "ch1rfn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Clothing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Medieval manuscripts, such as the gorgeously illustrated Luttrell Psalter made in the first half of the fourteenth century, reveal how contemporaries dressed. Men in the early fourteenth century wore their hair to chin or shoulder level, parted in the middle and framing their face. A century later, the fashion had changed completely, and men wore their hair very short, cut up the back of the head. It is difficult to generalise about facial hair; some men had moustaches, others had bushy beards or goatee-style beards, while yet others preferred to be clean-shaven. Women wore their hair very long, and fourteenth-century noblewomen often wore their hair in plaits or braids twisted into coils and pinned at each side of their head, a style similar to that worn by Princess Leia. Blonde hair, pale skin and a certain plumpness or voluptuousness were considered desirable in women, as poet Geoffrey Chaucer’s depiction of the great heiress Blanche of Lancaster in the 1360s makes apparent:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("She was bothe fair and bright…")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Right faire shuldres, and body long")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She hadde, and armes; every lith [limb]")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fattish, flesshy, not greet therwith;")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Right whyte handes, and nayles rede [nails red],")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rounde brestes; and of good brede [breadth]")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hyr hippes were, a streight flat bake [back]."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn18",
      "id": "ch1rfn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pale skin was prized as it signified wealth and privilege; most people worked outside all day, and only the wealthy were able to remain indoors and to have skin that was not tanned or damaged by the sun. To be ‘fattish’ and ‘fleshy’ in a world where few people had ample food also signified wealth. On the other hand, in his Miller’s Tale, Chaucer describes the miller’s beautiful and desirable young wife Alison thus: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("As any wezele hir body gent and smal")]), _vm._v(", ‘As any weasel, her body was"), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" graceful and slender’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn19",
      "id": "ch1rfn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The meaning of this comparison to a weasel is much debated, but Chaucer surely meant to pay Alison a compliment and did not intend the ‘slender’ remark pejoratively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both women and men covered their heads, with hats, caps, hoods, coifs, or, in the case of women, headdresses or veils. The working men depicted in the Luttrell Psalter wear coifs or hoods pulled over their heads, and the long peak of the hood falls past their shoulders. Edward II in the 1320s owned a black hat lined with red velvet and decorated with butterflies made of pearls and a white hat lined with green velvet and decorated with gold trefoils."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn20",
      "id": "ch1rfn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" When his wife Isabella of France moved to England in early 1308, her trousseau included two gold circlets and three hats or head-coverings adorned with rubies and emeralds, and Isabella’s daughter-in-law Philippa of Hainault wore ‘a hood made of brown scarlet studded with 154 stars of pearls and trimmed with gold’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn21",
      "id": "ch1rfn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Two noblewomen depicted eating at a table in the Luttrell Psalter wear their hair pinned in coils at each side, with a narrow band of material around their head holding in place a diaphanous veil, which falls down their backs. The seal of Edward I’s eldest granddaughter Eleanor, Lady Despenser (1292–1337), made in 1329, shows her wearing a floor-length gown and a simple veil, and the effigy of Eleanor’s daughter-in-law Elizabeth, Lady Despenser, who died in 1359 and was buried in Tewkesbury Abbey in Gloucestershire, depicts her in a square headdress which must have been the height of contemporary fashion. Both the Luttrell Psalter and the effigy of Blanche, Lady Grandisson (d. 1347), in the church of St Bartholomew, Much Marcle, Herefordshire, show that fourteenth-century noblewomen often covered their neck, chin and the sides of their faces with a wimple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When seventeen-year-old Constanza of Castile arrived in England in 1371, her new husband John of Gaunt, Duke of Lancaster, purchased almost 500 pearls to make a ‘fret’, i.e. a headdress of interlaced wire decorated with jewels, for her. Two years later, the duke bought two fillets, headbands also made of interlaced wire, for his daughters, thirteen-year-old Philippa and ten-year-old Elizabeth. Each had three balas rubies and twenty-eight pearls."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn22",
      "id": "ch1rfn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" The effigy of John’s mother Philippa of Hainault, Queen of England, in Westminster Abbey wears a reticulated headdress, where the hair was encased on either side of the head in bags made of gold or silver thread. Horned headdresses became fashionable in England in the early fifteenth century. Beatriz of"), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" Portugal, Countess of Arundel, Surrey and Huntingdon, was buried with her first husband in 1439, and their extant effigies show the countess wearing a horned headdress of astonishing width and height, with material draped over the two points and her hair gathered in large coils at each side of her head and encased in jewelled hairnets. Headdresses called hennins, in the shape of a cone or steeple and often remarkably high, also became fashionable, while another popular horned style of the era was the bourrelet or escoffion, made from a thick padded roll of material. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotula")]), _vm._v(" recommended that noblewomen should wear musk, cloves, nutmeg or ‘other sweet-smelling substances’ in their hair, under their veil or head-covering, and also shared numerous recipes for colouring the hair blonde, black, or white. For whitening the hair, the authors recommended, not terribly helpfully, that women should ‘catch as many bees as possible in a new pot and set it to burn’. The dead, burnt bees were to be mixed with oil and rubbed over the hair."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn23",
      "id": "ch1rfn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone, men and women of all ranks, wore hose, a kind of leggings, to cover their legs. During the blazingly hot, dry summer of 1326, Edward II bought linen cloth to make hose for the archers who formed his bodyguard, though in winter, hose would be made of wool or another thick material for warmth."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn24",
      "id": "ch1rfn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" In the northern European climate, wearing thick clothes in winter assumed a great importance, and people often wore animal fur to keep warm. Miniver, very costly white or light grey fur made from the winter coat of the squirrel, was worn by wealthy noble or royal people. Other varieties of fur were ‘budge’ or lambskin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scrimpyns")]), _vm._v(" (cheap and poor quality furs), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("roskyn")]), _vm._v(" (fur of the squirrel in summer), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polan")]), _vm._v(" (fur of the black squirrel), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stranglin")]), _vm._v(" (fur of the squirrel around Michaelmas, 29 September) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stradlynge")]), _vm._v(" (fur of the squirrel between Michaelmas and winter). In 1324, a man’s jerkin made of six pieces of otter skin cost 24d."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn25",
      "id": "ch1rfn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both men and women often wore "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cotes")]), _vm._v(" or tunics, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("courtepies")]), _vm._v(" or short jackets, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("surcotes")]), _vm._v(" or overtunics, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cotes hardies")]), _vm._v(", a long, fitted outer garment with long sleeves and sometimes hoods, which was buttoned or laced up the front, and, when the weather dictated, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mantel")]), _vm._v(" or cloak. Wills and other documents often used the phrase ‘a robe of/with garments’, which meant a complete set of clothes. One ‘robe with three garments’ consisted of a tunic, an overtunic and a cloak. Men wore shirts tied to their hose, and women wore floor-length gowns with long sleeves. ‘Sideless surcoats’ or over-gowns were very fashionable in the fourteenth century,"), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" with an undergown in a contrasting colour showcased by a large cut-out at each side. Medieval fashion could be as absurd and impractical as in later centuries; in the late 1300s, Richard II and his youthful male courtiers wore "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cracowes")]), _vm._v(", soft shoes with toes so long that they had to be tied to the wearer’s leg if he wished to be able to walk in them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Medieval people were not free to dress however they wished to express themselves. In England, the first sumptuary laws, the official guidelines which dictated the clothes which different ranks of society were allowed to wear, date from Edward III’s reign. Unofficially, however, they existed long before that, and it would always have been immediately obvious, from fabric, fur, embroidery, jewellery, and so on, where people stood in the strict social hierarchy of medieval England. In March 1322, when Edward II had his cousin Thomas, Earl of Lancaster beheaded outside Thomas’s own castle at Pontefract in Yorkshire, he forced him to wear the striped cloth which the squires of Thomas’s household wore. This was intended as a deliberate humiliation of a man of royal birth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As an example of medieval sumptuary laws, knights with an annual income of under 200 marks and their families were not allowed to wear cloth worth more than six marks (960d), and women were not allowed to wear jewels except in their hair. Carters, cowherds and everyone else who worked on the land and did not have 40s of goods could wear nothing except russet or blanket cloth at 12d an ell (45 inches), and rope belts."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn26",
      "id": "ch1rfn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Russet cloth was coarse and either grey or black, and cost 12d or 12½d an ell in the 1320s. By way of contrast, the rich and colourful silken fabrics worn by those of much higher rank cost somewhere around 120d an ell."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn27",
      "id": "ch1rfn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" As well as the sumptuary laws, in May 1327 Edward III ordained that ‘no man or woman … in England, Ireland or Wales, shall, after Christmas next, use cloth of his or her own buying which was not made in England, Ireland or Wales’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn28",
      "id": "ch1rfn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Geoffroi de Charny (c. 1300–56), a renowned French knight who spent time in England in the 1340s as a prisoner of war, composed three works on chivalry. He believed that women ‘should pay more attention to their physical appearance and be more splendidly adorned’ with jewels and ornaments than men. Charny warned, however, that excessive pride in one’s dress could easily lead to a person forgetting God, and ‘if you do not remember God, God will not remember you’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn29",
      "id": "ch1rfn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Clothes were used to signal and to set apart women who were deemed ‘disreputable’ or ‘of bad character’. A proclamation was made in London in 1281"), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" that ‘no woman of the town shall henceforth go to market nor into the highway out of her house with a hood furred with budge, whether it be of lamb or of conies [rabbit], upon pain of forfeiting her hood’. It went on to say that ‘brewsters, nurses, other servants, and women of disreputable character’ – why any of these groups of women were ‘disreputable’ was not explained – must not wear expensive miniver fur ‘after the manner of reputable women’. In 1351, it was proclaimed in London that ‘common lewd women’ must not wear any garment lined with fur, sendal or samite cloth, ‘or any other noble lining’, either in winter or summer. The women were ordered to wear, both day and night, ‘a hood of cloth of ray’, i.e. striped cloth, so that everyone in the city, both residents and visitors, ‘may have knowledge of what rank they are’. In 1381/82, it was once more ‘ordained that common harlots and all women of bad character shall wear rayed [striped] hoods and use no manner of fur’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes#ch1fn30",
      "id": "ch1rfn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f2c324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter1.vue
// module id = 78
// module chunks = 0